// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: false,
  settings: {
      preRegOnly: "ngssc-token-1774004950406-6" as any,
      newsletterId: "ngssc-token-1774004950406-3" as any,
      accountSystem: {
          isMellon: "ngssc-token-1774004950406-10" as any,
          isPlatform: "ngssc-token-1774004950406-4" as any,
          isFirebase: "ngssc-token-1774004950406-5" as any,
      },
      mellon: {
          url: "ngssc-token-1774004950406-7" as any,
          cookieDomain: "ngssc-token-1774004950406-1" as any,
          application: {
                id: "ngssc-token-1774004950406-2" as any,
                countryId: "ngssc-token-1774004950406-11" as any,
                instanceId: "ngssc-token-1774004950406-8" as any,
                languageId: "ngssc-token-1774004950406-9" as any
          }
      },
      firebase: {
          apiKey: 'AIzaSyB1ZUy10Xp9EXUSirnWBsX2cQ2S1sTLGxU',
          authDomain: 'test-b3421.firebaseapp.com',
          databaseURL: 'https://test-b3421.firebaseio.com',
          projectId: 'test-b3421',
          storageBucket: 'test-b3421.appspot.com',
          messagingSenderId: '795582921197'
      }
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
